<template>
    <MainContent>
        <template v-slot:header>
            <PageTitle title="Renovar deportista"/>
        </template>
        <template v-slot:content>
            <RenovarBase/>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import PageTitle from '@/components/backend/components/PageTitleComponent';
    import RenovarBase from './components/RenovarBase';

    export default {
        components: { MainContent, PageTitle, RenovarBase }
    }
</script>